// extracted by mini-css-extract-plugin
module.exports = {"artistPill":"ArtistPill_artistPill__1hmD6","isPassive":"ArtistPill_isPassive__1SNoG","artistCoverImage":"ArtistPill_artistCoverImage__3uHcF"};